// The top of every Encaissement sheet (operator 2026-09-26): the page title is
// gone; the view chips — Arrivées · Départs · Non facturés · Clients débiteurs
// — sit on the left, larger, and « Actualiser » / « Imprimer » on the right.
// The day bar, where a sheet has one, comes right underneath. Never printed.

import type { ReactNode } from 'react';

export interface SheetTopProps {
  /** The view chips, from the Encaissement screen; absent when a sheet stands alone. */
  nav?: ReactNode;
  onRefresh: () => void;
  canPrint: boolean;
}

export function SheetTop({ nav, onRefresh, canPrint }: SheetTopProps) {
  return (
    <div className="pms-sheet-top pms-no-print">
      <div className="pms-sheet-nav">{nav}</div>
      <div className="pms-form-actions">
        <button type="button" className="pms-mini" onClick={onRefresh}>
          Actualiser
        </button>
        <button type="button" className="auth-btn" onClick={() => window.print()} disabled={!canPrint}>
          Imprimer
        </button>
      </div>
    </div>
  );
}
